<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">音乐名称：</div>
                        <el-input v-model="artName"  placeholder="请输入音乐名称" clearable ></el-input>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">分类：</div>
                        <!-- <el-cascader v-model="categoryId" :options="categoryList" :props="{ expandTrigger: 'hover' }"
                            clearable></el-cascader> -->
                            <el-select v-model="categoryId1" placeholder="请选择分类类型">
                                <div  v-if="musictype == 1">
                                    <el-option  v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                                </div>
                                <div  v-if="musictype == 2">
                                    <el-option  v-for="item in categoryListSecond" :key="item.id" :label="item.title" :value="item.id"></el-option>
                                </div>
                                <div  v-if="musictype == ''">
                                    <el-option  v-for="item in categoryListAll" :key="item.id" :label="item.title" :value="item.id"></el-option>
                                </div>
                            </el-select>
                    </div>
                </el-col>
                
                <el-col :span="4">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">属性：</div>
                            <el-select v-model="musictype" placeholder="请选择属性类型">
                                <el-option v-for="item in topicOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">上传人：</div>
                        <el-input v-model="uploadname"  placeholder="请输入上传人" clearable ></el-input>
                    </div>
                </el-col>
               
                <el-col :span="4" :offset="2">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 新增文章按钮 -->
        <div class="whiteBg main-middle">
            <div class="box box-align-center mt-btns">
                <el-button type="primary" plain icon="el-icon-plus" @click="buildNewTopic">新增</el-button>
            </div>
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" ref="fbTable"
                v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="10"
                @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="60%" destroy-on-close
            :close-on-click-modal="false">
            <el-form :model="ruleForm" :rules="rules" label-width="120px" label-position="right" ref="ruleForm">
                <!-- <el-row>
                    <el-col :span="8">     
                    </el-col>
                    <el-col :span="8" :offset="2">
                        <el-form-item label="描述信息：">
                            <el-input v-model="ruleForm.desc" placeholder="请输入描述信息"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row> -->
                <el-form-item label="音乐名称：" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请输入音乐名称"></el-input>
                </el-form-item>
                <el-form-item label="属性：" prop="type">
                    <el-radio v-model="ruleForm.type" label="1" @change="changgeType" >主音频</el-radio>
                    <el-radio v-model="ruleForm.type" label="2" @change="changgeType" >混音</el-radio>
                </el-form-item>
                <el-form-item label="封面图：" prop="cover">
                    <el-row type="flex" align="middle">
                        <el-col :span="15">
                            <el-upload class="upload-demo" :action="uploadImg" name="file" accept=".jpeg,.jpg,.png,.gif,.bmp"
                                :on-success="handlePosterPreview" :headers="headers"  :show-file-list="false" >
                                <div v-if="!ruleForm.cover">
                                    <i class="el-icon-upload"></i>
                                    <!-- <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
                                </div>
                                <div v-else>
                                    <img class="img-style" :src="ruleForm.cover"   alt="">
                                </div>
                            </el-upload>
                            <div style="font-size: 13px;">建议上传图片尺寸：2倍图 130  × 128px</div>
                            <!-- <el-upload
                                :action="uploadImg"
                                name="file"
                                list-type="picture-card"
                                :on-success="handlePosterPreview"
                                :show-file-list="false"
                               
                                :headers="headers"
                            >
                                <img v-if="form.goodsImage" :src="form.goodsImage" style="width: 147px; height: 147px" />
                                <div  style="color:#606266">上传图片</div>
                    </el-upload> -->
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="权重：" prop="sort">
                    <el-input v-model="ruleForm.sort" style="width: 200px; margin-right: 20px;" placeholder="请输入权重"></el-input>
                </el-form-item>
                <el-form-item label="分 类：" prop="categoryId">
                    <!-- @change="handleCategoryChange" -->
                        <el-select v-model="ruleForm.categoryId" placeholder="请选择跳转类型">
                            <div  v-if="ruleForm.type == 1">
                                <el-option  v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                            </div>
                            <div  v-if="ruleForm.type == 2">
                                <el-option  v-for="item in categoryListSecond" :key="item.id" :label="item.title" :value="item.id"></el-option>
                            </div>
                            <div  v-if="ruleForm.type == ''" >
                                <el-option disabled label=" 请先选择属性 "></el-option>
                            </div>
                        </el-select>
                </el-form-item>
                <el-form-item label="上传音乐：" prop="audioUrl">
                    <!-- <el-row type="flex" align="middle">
                        <el-col :span="15">
                            <el-upload class="upload-demo" :action="uploadImg" name="file"
                                :on-success="handlePosterPreview" :headers="headers" :show-file-list="false" drag>
                                <div v-if="!ruleForm.cover">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </div>
                                <div v-else>
                                    <img :src="ruleForm.cover" alt="">
                                </div>
                            </el-upload>
                        </el-col>
                        <el-col :span="5" :offset="1">
                            <div class="main-red up-tip">(封面图尺寸为:690px X 210px)</div>
                        </el-col>
                    </el-row> -->
                    <!-- :on-error="handleError"     :before-upload="beforeUpload" -->
                    <el-upload
                        :action="uploadImg" 
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        accept=".mp3, .wav, .m4a, .aiff, .alac, .aac, .flac"
                        class="audio-uploader"
                    >
                    <el-button slot="trigger" size="small" type="primary">上传音乐</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传MP3格式的音乐文件</div> -->
                    </el-upload>
                </el-form-item>
                <audio controls :src="ruleForm.audioUrl"  ref="audioController" v-if="ruleForm.audioUrl && addBanner"></audio>
                <audio controls ref="audioController" :src="ruleForm.audioUrl"  v-if="ruleForm.audioUrl && !addBanner"></audio>
                <el-form-item label="音乐时长：" prop="totalTime">
                    <el-input v-model="ruleForm.totalTime" style="width: 200px; margin-right: 20px;" placeholder="请输入音乐时长"></el-input>
                </el-form-item>
                <el-form-item label="推荐标签：" prop="tag1">
                    <el-input v-model="ruleForm.tag1" style="width: 200px; margin-right: 20px;" placeholder="请输入推荐标签    0/6"></el-input>
                    <el-input v-model="ruleForm.tag2" style="width: 200px; margin-right: 20px;" placeholder="请输入推荐标签    0/6"></el-input>
                </el-form-item>
                <el-form-item label="是否发布到线上"  prop="isOnline">
                    <!-- v-model="form.type" --> 
                     <el-radio v-model="ruleForm.isOnline" label="1">是</el-radio>
                    <el-radio v-model="ruleForm.isOnline" label="0">否</el-radio>
                </el-form-item>
                <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                    <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
                    <el-button type="danger" plain @click="() => addVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>

        <el-dialog title="添加文章" append-to-body width="80%" :visible.sync="showAddArticleVisible" destroy-on-close
            :close-on-click-modal="false">
            <acticle-common @close-dialog="() => showAddArticleVisible = false"
                @save-data="getSelection" :list="chapterTableData"></acticle-common>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import ActicleCommon from '@/components/common/articleCommon/index'
import host from '@/api/index';
import { getSubjectList, saveSubject, publishSubject, subjectOffline, subjectDetail, delSubject, getAllClassification } from '@/api/index';
import { AddMusic, fenlieMusic, MusicList, MusicUpdate, MusicDelete ,MusicToUpdate} from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, uniqueBy } from '@/utils/utils';
import { statusList } from '@/utils/commonData';
var that = null;
export default {
    components: {
        DyTable,
        ActicleCommon,
    },
    data() {
        const { showArticle } = this;
        const { delArticle } = this;
        const { offlineTopic } = this;
        const { onLineTopic } = this;
        const { editArticle } = this;
        const { delDialogArticle } = this;
        return {
            showAddArticleVisible: false,
            changeType:'',
            changcategoryId:'',
            artName: '',
            uploadname:'',
            categoryId1:'',
            musictype:'',
            activeName: 'first',
            tableLoading: true,
            addBanner:'',
            fileList:[],
            topicId: '',
            dialogTitle: '新建/修改',
            topicOptions: [
                { label: '主音频', value: 1 },
                { label: '混音', value: 2 },
            ],
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'title',
                    title: '音乐名称'
                },
                {
                    key: 'categoryTitle',
                    title: '分类'
                },
                {
                    key: 'sort',
                    title: '权重'
                },
                {
                    key: '',
                    title: '属性',
                    render: ({ row }) => {
                        return (
                            <div>
                            {row.type == 1? (
                                <div>主音频</div>
                            ) :( <div>混音</div>) }
                            </div>
                        );
                    }
                },
                {
                    key: '',
                    title: '推荐标签',
                    render: ({ row }) => {
                        return (
                            <div>
                            {row.tagNameList[0] ? (
                            <el-tag  plain round size='medium  '>
                                {row.tagNameList[0]}
                            </el-tag>) :( <div></div>) }
                            {row.tagNameList[1] ? (
                            <el-tag  plain round size='medium  '>
                                {row.tagNameList[1]}
                            </el-tag>) :( <div></div>) }

                            </div>
                        );
                    }
                },
                {
                    key: 'updateAt',
                    title: '更新时间',
                    width: 200,
                },
                {
                    key: 'username',
                    title: '上传人',
                },
                {
                    key: '',
                    title: '操作',
                    width: 200,
                    render: ({ row }) => {
                        
                            return (
                                <div>
                                    <el-link type="info" onClick={() => editArticle(row.id)}>编辑</el-link>
                                    <el-link type="danger" style="margin-left:12px" onClick={() => delArticle(row.id)}>删除</el-link>
                                </div>
                            );
                        
                    }
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            audioSrc: '',
            fileList: [],
            ruleForm: {//新建直播表单数据
                musicId: '',
                title: '',
                cover: '',
                categoryId:'',
                categoryTitle: '',
                audioUrl: '',
                totalTime: '',
                type:'',
                tag1:'',
                tag2:'',
                isOnline:'',
                fileName:'',
                fileUrl :'',
                sort:'',
                
            },
            rules: {
                title: [ { required: true, message: '请输入分类名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择属性', trigger: 'blur' }],
                cover: [{ required: true, message: '请上传图片', trigger: 'blur' }],
                categoryId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
                audioUrl: [{ required: true, message: '请上传音乐', trigger: 'blur' }],
                totalTime: [{ required: true, message: '请选择音乐时长', trigger: 'blur' }],
                tag1: [{ required: true, message: '请输入推荐标签', trigger: 'blur' }],
                isOnline: [{ required: true, message: '请选择是否发布', trigger: 'blur' }],
                sort: [{ required: true, message: '请输入权重', trigger: 'blur' }]
                
            },
            chapterTableLoading: true,

            chapterTableData: [],
            bfChapterTableData: [],//删除后备份，保存使用
            addVisible: false,
            addChapterVisible: false,
            currentTopStatus: 0,//点击文章管理时的状态
            categoryList: [],
            categoryListSecond:[],
            categoryListAll:[],
            categoryId: '',
        }
    },
    mounted() {
        that = this;
        that.getList();
        that.getAllClassification()
        
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token') // 直接从本地获取token就行
            };
        },

    },

    methods: {
        // handleCategoryChange(selectedCategoryId) {
        //     if (this.categoryList.some(item => item.id === selectedCategoryId)) {
        //         this.ruleForm.type = 1; // 主音频
        //     } else if (this.categoryListSecond.some(item => item.id === selectedCategoryId)) {
        //         this.ruleForm.type = 2; // 混音
        //     } else {
        //         this.ruleForm.type = ''; // 其他
        //     }
    
        // },
        changgeType(selectedCategoryId){
            // console.log("!!!!!",this.ruleForm.type)
            // console.log("$$$$$",selectedCategoryId)
            // console.log("^^^",this.changeType)
            if(this.changeType  != selectedCategoryId){
                this.ruleForm.categoryId = '';
            }else{
                this.ruleForm.categoryId = that.changcategoryId
            }  
        },

  
        //保存选择后的数据
        getSelection(arr) {
            console.log('选择', arr);
            let data = arr.map((item, index) => {
                return {
                    serialNum: index + 1,
                    articleId: item.id,
                    articleTitle: item.title,
                    articleType: item.type,
                    classificationName: item.classificationName,
                    publishStatus: item.publishStatus,
                    isDelete: false
                }
            });
            let currentArr = JSON.parse(JSON.stringify(that.chapterTableData.concat(data)));
            that.chapterTableData = uniqueBy(currentArr, 'articleId');
            console.log('保存', that.chapterTableData);
            that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
        },
        //新建专题
        buildNewTopic() {
            that.addBanner  = true
            that.dialogTitle = '新建/修改';
            that.fileList = [];
            that.audioSrc = '',
            that.ruleForm = {
                musicId: '',
                title: '',
                cover: '',
                categoryId:'',
                categoryTitle: '',
                audioUrl: '',
                totalTime: '',
                type:'',
                tag1:'',
                tag2:'',
                isOnline:'',
                sort:'',
            }
            that.addVisible = true;
        },
        //专题封面图
        handlePosterPreview(file) {
            console.log(file);
            // this.ruleForm.cover = file.data.name;
            this.url1 =  process.env.VUE_APP_API_URL_UPLOAD
            console.log(this.url1 + '/upload/' + file.data.name)
            this.ruleForm.cover  = this.url1 + '/upload/' + file.data.name
            this.$nextTick(() => {
              this.$forceUpdate()
            })
        },
        //上传音频
        handleSuccess(response, file,fileList) {
            console.log(file);
            //上传两个音乐时候，会删除第一个
            this.fileList = [file];

            // this.ruleForm.fileList = fileList.data.url;
            this.url1 =  process.env.VUE_APP_API_URL_UPLOAD
            // that.ruleForm.title = file.name;
            // that.ruleForm.audioUrl = file.response.data.url;
            console.log(this.url1 + '/upload/' + file.response.data.name)
            this.ruleForm.audioUrl  = this.url1 + '/upload/' + file.response.data.name
            this.audioSrc = this.ruleForm.audioUrl
            this.$nextTick(() => {
              this.$forceUpdate()
            })
            
            console.log("!!!",this.audioSrc)

        },
        //重置列表
        resetList() {
            that.currentPage = 1;
            that.artName = '';
            that.uploadname = '';
            that.topicId = '';
            that.categoryId1 = '';
            that.musictype = '',
            that.getList();
            that.getAllClassification()
        },
        //编辑专题
        editArticle(id) {
            that.addBanner  = false
            that.addVisible = true
            that.getupdateToBanner(id)
    
            

        },
        getupdateToBanner(id) {
            that.tableLoading = true;
            let info = {
                id:id
            };
            console.log(info);
            var data = info;
            MusicUpdate(data).then((res) => {
                if (res.result == 1) {
                // that.getJump()
                // var ress = JSON.parse(decrypt(res.data));
                var ress = res.data;
                console.log('编辑11列表', ress);

                that.ruleForm.musicId = ress.id,
                that.ruleForm.title = ress.title,
                that.ruleForm.cover  = ress.cover,
                that.ruleForm.categoryId = ress.categoryId,
                that.ruleForm.totalTime = ress.totalTime,
                that.ruleForm.type = ress.type.toString(),
                that.ruleForm.tag1 = ress.tag1,
                that.ruleForm.tag2 = ress.tag2,
                that.ruleForm.isOnline = ress.isOnline,
                that.ruleForm.audioUrl = ress.audioUrl
                that.changeType = ress.type.toString()
                that.changcategoryId = ress.categoryId,
                that.ruleForm.sort = ress.sort,
                that.fileList = [{ name: that.ruleForm.title, url: that.ruleForm.audioUrl }];
                that.tableLoading = false;
                that.chapterTableLoading = false;
                } else {
                that.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'error',
                });
                }
            });
            },
        //删除专题
        delArticle(id) {
            that.$confirm('确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    id:id
                };
                console.log("123",info);
                var data = info;
                MusicDelete(data).then((res) => {
                    that.getList();
                    that.getAllClassification()
                });
            })
        },
        //删除弹窗里文章
        delDialogArticle(obj) {
            console.log(obj);
            let index = that.chapterTableData.findIndex(item => item.articleId == obj.articleId);
            that.chapterTableData.splice(index, 1);
            if(that.bfChapterTableData[index].id != undefined){
                that.bfChapterTableData[index].isDelete = true;
            }else{
                that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
            }
        },


        // 保存
        submitForm(formName)  {
            that.$refs[formName].validate((valid) => {
            if (valid) {

            if(that.addBanner){
                var info = {
                    title: that.ruleForm.title,
                    cover: that.ruleForm.cover,
                    categoryId:that.ruleForm.categoryId,
                    userId: localStorage.getItem('userId'),
                    audioUrl: that.ruleForm.audioUrl,
                    tag1: that.ruleForm.tag1,
                    tag2: that.ruleForm.tag2,
                    totalTime:that.ruleForm.totalTime,
                    type: that.ruleForm.type,
                    isOnline: that.ruleForm.isOnline,
                    sort: that.ruleForm.sort,

                };
            }else{
                var info = {
                    id: that.ruleForm.musicId,
                    title: that.ruleForm.title,
                    cover: that.ruleForm.cover,
                    categoryId:that.ruleForm.categoryId,
                    userId: localStorage.getItem('userId'),
                    audioUrl: that.ruleForm.audioUrl,
                    tag1: that.ruleForm.tag1,
                    tag2: that.ruleForm.tag2,
                    totalTime:that.ruleForm.totalTime,
                    type: that.ruleForm.type,
                    isOnline: that.ruleForm.isOnline,
                    sort: that.ruleForm.sort,
                };
            }

            console.log(info);
            var data = info;
            if(that.addBanner){
            console.log("新增")
            AddMusic(data).then((res) => {
            if (res.result == 1) {
                that.getList();
                that.dialogTableAdd = false;
                that.addVisible = false
            } else {
                that.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'error'
                });
            }
            });
            }else{
            console.log("修改")
            MusicToUpdate(data).then((res) => {
            if (res.result == 1) {
                that.getList();
                that.dialogTableAdd = false;
                that.addVisible = false
            } else {
                that.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'error'
                });
            }
            });
            }

            } else {
            console.log('error submit!!');
            return false;
            }
        });
        },
        // 提交表单
        // submitForm(formName) {
        //     that.$refs[formName].validate((valid) => {
        //         if (valid) {
        //             var info = that.ruleForm;
        //             info.classification = info.classification && info.classification.length > 0 ? info.classification[info.classification.length - 1] : '';
        //             console.log(info, '我是表单');
        //             var data = encrypt(JSON.stringify(info));
        //             saveSubject(data).then((res) => {
        //                 if (res.result == 1) {
        //                     // var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
        //                     console.log(res);
        //                     this.addVisible = false;
        //                     that.currentPage = 1;
        //                     that.getList();
        //                     that.getAllClassification()
        //                     this.$message({
        //                         showClose: true,
        //                         message: '保存成功',
        //                         type: 'success'
        //                     });
        //                 } else {
        //                     this.$message({
        //                         showClose: true,
        //                         message: res.msg,
        //                         type: 'error'
        //                     });
        //                 }
        //             });
        //         } else {
        //             console.log('error submit!!');
        //             return false;
        //         }
        //     });
        // },
        //添加章节
        showArticle(id) {
            let info = {
                id
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            subjectDetail(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('编辑专题', ress);
                    that.ruleForm = ress;
                    that.ruleForm.desc = ress.description;
                    that.chapterTableData = ress.subjectArticleVos.map((item, index) => {
                        return {
                            serialNum: index + 1,
                            isDelete: false,
                            ...item
                        }
                    });
                    that.bfChapterTableData = JSON.parse(JSON.stringify(that.chapterTableData));
                    that.currentTopStatus = ress.status;
                    that.addChapterVisible = true;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        onCurrentChange(val) {
            this.currentPage = val
            this.getList()
            that.getAllClassification()
        },
        getList() {
            that.tableLoading = true;
            let info = {
                // id: that.topicId,
                // classification: that.categoryId[that.categoryId.length - 1],
                pageNum: that.currentPage,
                pageSize: that.pageSize,
                title: that.artName,
                name:that.uploadname,
                categoryId:that.categoryId1,
                type: that.musictype
            };
            console.log(info);
            var data = info;
            MusicList(data).then((res) => {
                if (res.result == 1) {
                    var ress = res.data;
                    console.log('音乐列表', ress);
                    that.getAllClassification()
                    that.total = ress.total;
                    that.currentPage = ress.pageNum;
                    that.tableData = ress.list
                    // .map(item => {
                    //     return {
                    //         ...item,
                    //         // statusTxt: statusList[item.status].label,
                    //         // operatetime: formatDate(new Date(item.operatetime), 'yyyy-MM-dd hh:mm:ss')
                    //     }
                    // });
                    that.tableLoading = false;
                    that.chapterTableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取分类
        getAllClassification() {
            let info = {};
            console.log(info);
            var data = info;
            fenlieMusic(data).then((res) => {
                if (res.result == 1) {
                    var ress = res.data;
                    // console.log('获取所有分类1111', ress);
                        that.categoryList = ress.first;
                        that.categoryListSecond = ress.second
                        that.categoryListAll = [...that.categoryList,...that.categoryListSecond]
                        console.log('分类1', that.categoryList); 
                        console.log('分类2', that.categoryListSecond); 
                        console.log('分类all', that.categoryListAll); 
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取所有分类(树型结构)
        // getAllClassifica() {
        //     let info = {};
        //     console.log(info);
        //     var data = encrypt(JSON.stringify(info));
        //     getAllClassification(data).then((res) => {
        //         if (res.result == 1) {
        //             var ress = JSON.parse(decrypt(res.data));
        //             console.log('获取所有分类', ress);
        //             if (ress.length > 0) {
        //                 that.categoryList = that.listFor(ress);
        //                 console.log('分类', that.categoryList);
        //             }
        //         } else {
        //             that.$message({
        //                 showClose: true,
        //                 message: res.msg,
        //                 type: 'error'
        //             });
        //         }
        //     });
        // },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childClass != '' && arr[i].childClass != null && arr[i].childClass != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childClass),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childClass),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
    min-width: 100px;
    text-align: center;
    padding: 0;
}

/deep/.el-dropdown {
    margin-right: 10px;
}

/deep/.el-form-item__content {
    margin-left: 0 !important;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
    padding: 20px 15px;
    // border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>